import { DesktopDateTimePicker } from '@mui/x-date-pickers';
import { TextField } from '@mui/material';

const getCalendarSlotProps = (lightMode) => ({
  sx: {
    bgcolor: lightMode ? '#ffffff' : '#2e2e2e',
    color: lightMode ? '#333' : '#fff',
    '& .MuiPickersCalendarHeader-root, & .MuiSvgIcon-root': { color: lightMode ? '#333' : '#fff' },
    '& .MuiDayCalendar-weekDayLabel': { color: lightMode ? '#666' : '#aaa' },
    '& .MuiPickersDay-root': { color: lightMode ? '#333' : '#fff' },
    '& .Mui-selected': { bgcolor: '#5364FF !important', color: '#fff !important' },
    '& .MuiDialogActions-root .MuiButton-root': { 
        color: lightMode ? '#5364FF' : '#fff',
        fontWeight: 'bold'
    },
  }
});

export const DatePickerYearMonthDayHoursMinutes = ({ label, value, onChange, inputSx }) => {
    return (
        <DesktopDateTimePicker 
        label={label}
          value={value}
          onChange={onChange}
          views={['year', 'month', 'day', 'hours', 'minutes']}
          format="YYYY년 MM월 DD일 HH시 mm분"     
          enableAccessibleFieldDOMStructure={false}
          slots={{ textField: TextField }}
          slotProps={{
            textField: {
              fullWidth: true,
              size: 'medium',
              sx: {
                '& .MuiOutlinedInput-root': {
                  borderRadius: '30px',
                  '& input': {
                    fontSize: '32px',
                    color: 'white',
                  },
                  '& fieldset': {
                    borderColor: 'rgba(255, 255, 255, 0.5)',
                  },
                  '&:hover fieldset': {
                    borderColor: '#5364FF',
                  },
                  '&.Mui-focused fieldset': {
                    borderColor: '#6C7AFC',
                  },
                },
                '& .MuiInputLabel-root': {
                  fontSize: '22px',
                  color: 'white',
                },
                '& .MuiInputLabel-root.Mui-focused': {
                  color: 'white',
                },
                ...inputSx
              },
            },
          }}
        />
    )
}

export const DatePickerYearMonthDayHours = ({ label, value, onChange, maxDate, inputSx, lightMode }) => {
    return (
        <DesktopDateTimePicker 
        label={label}
          value={value}
          onChange={onChange}
          maxDate={maxDate}
          views={['year', 'month', 'day', 'hours']}
          format="YYYY년 MM월 DD일 HH시"     
          ampm={false}
          enableAccessibleFieldDOMStructure={false}
          slots={{ textField: TextField }}
          slotProps={{
            textField: {
              fullWidth: true,
              size: 'medium',
              sx: {
                '& .MuiOutlinedInput-root': {
                  borderRadius: '30px',
                  '& input': { fontSize: '32px', color: lightMode ? '#333' : 'white', },
                  '& fieldset': { borderColor: lightMode ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.5)', },
                  '&:hover fieldset': { borderColor: '#5364FF', },
                  '&.Mui-focused fieldset': { borderColor: '#6C7AFC', },
                },
                '& .MuiInputLabel-root': { fontSize: '22px', color: lightMode ? '#666' : 'white', },
                '& .MuiInputLabel-root.Mui-focused': { color: lightMode ? '#1976d2' : 'white', },
                ...inputSx
              },
            },
            desktopPaper: getCalendarSlotProps(lightMode)
          }}
        />
    )
}

export const DatePickerYearMonthDay = ({ label, value, onChange, maxDate, inputSx, lightMode }) => {
    return (
        <DesktopDateTimePicker 
        label={label}
          value={value}
          maxDate={maxDate}
          onChange={onChange}
          views={['year', 'month', 'day']}
          format="YYYY년 MM월 DD일"     
          enableAccessibleFieldDOMStructure={false}
          slots={{ textField: TextField }}
          slotProps={{
            textField: {
              fullWidth: true,
              size: 'medium',
              sx: {
                '& .MuiOutlinedInput-root': {
                  borderRadius: '20px',
                  '& input': { fontSize: '32px', color: lightMode ? '#333' : 'white', },
                  '& fieldset': { borderColor: lightMode ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.5)', },
                  '&:hover fieldset': { borderColor: '#5364FF', },
                  '&.Mui-focused fieldset': { borderColor: '#6C7AFC', },
                },
                '& .MuiInputLabel-root': {
                  fontSize: '32px',
                  color: lightMode ? '#666' : 'white', 
                  transform: 'translate(24px, 30px) scale(2)',
                },
                '& .MuiInputLabel-root.MuiInputLabel-shrink': { transform: 'translate(20px, -14px) scale(0.8)', },
                '& .MuiInputLabel-root.Mui-focused': { color: lightMode ? '#1976d2' : 'white', },
                '& .MuiSvgIcon-root': { fontSize: '32px', color: lightMode ? '#666' : 'white', },
                ...inputSx
              },
            },
            desktopPaper: getCalendarSlotProps(lightMode)
          }}
        />
    )
}

export const DatePickerYearMonth = ({ label, value, onChange, inputSx }) => {
    return (
        <DesktopDateTimePicker 
        label={label}
          value={value}
          onChange={onChange}
          views={['year', 'month']}
          format="YYYY년 MM월"   
          enableAccessibleFieldDOMStructure={false}
          slots={{ textField: TextField }}  
          slotProps={{
            textField: {
              fullWidth: true,
              size: 'medium',
              sx: {
                '& .MuiOutlinedInput-root': {
                  borderRadius: '30px',
                  '& input': {
                    fontSize: '32px',
                    color: 'white',
                  },
                  '& fieldset': {
                    borderColor: 'rgba(255, 255, 255, 0.5)',
                  },
                  '&:hover fieldset': {
                    borderColor: '#5364FF',
                  },
                  '&.Mui-focused fieldset': {
                    borderColor: '#6C7AFC',
                  },
                },
                '& .MuiInputLabel-root': {
                  fontSize: '22px',
                  color: 'white',
                },
                '& .MuiInputLabel-root.Mui-focused': {
                  color: 'white',
                },
                ...inputSx
              },
            },
          }}
        />
    )
}

export const DateTimePicker = ({ mode, label, value, onChange, maxDate, inputSx, lightMode }) => {    
    return (  
        mode === 5 || mode === 15 ?
        <DatePickerYearMonthDayHoursMinutes label={label} value={value} onChange={onChange} inputSx={inputSx}/>
        :            
        mode === 60 ?
        <DatePickerYearMonthDayHours label={label} value={value} onChange={onChange} maxDate={maxDate} inputSx={inputSx} lightMode={lightMode}/>
        :            
        mode === 24 ?
        <DatePickerYearMonthDay label={label} value={value} onChange={onChange} maxDate={maxDate} inputSx={inputSx} lightMode={lightMode}/>
        :            
        mode === 30 ?
        <DatePickerYearMonth label={label} value={value} onChange={onChange} inputSx={inputSx}/>
        :            
        <DatePickerYearMonthDayHoursMinutes label={label} value={value} onChange={onChange} inputSx={inputSx}/> 
    )
}

export default function DatePicker({ label, value, onChange, inputSx }) {
    return (
        <DesktopDateTimePicker 
        label={label}
          value={value}
          onChange={onChange}
          views={['year', 'month']}
          format="YYYY년 MM월" 
          enableAccessibleFieldDOMStructure={false}
          slots={{ textField: TextField }}
          slotProps={{
            textField: {
              fullWidth: true,
              size: 'medium',
              sx: {
                '& .MuiOutlinedInput-root': {
                  borderRadius: '30px',
                  '& input': {
                    fontSize: '32px',
                    color: 'white',
                  },
                  '& fieldset': {
                    borderColor: 'rgba(255, 255, 255, 0.5)',
                  },
                  '&:hover fieldset': {
                    borderColor: '#5364FF',
                  },
                  '&.Mui-focused fieldset': {
                    borderColor: '#6C7AFC',
                  },
                },
                '& .MuiInputLabel-root': {
                  fontSize: '22px',
                  color: 'white',
                },
                '& .MuiInputLabel-root.Mui-focused': {
                  color: 'white',
                },
                ...inputSx
              },
            },
          }}
        />
    )
}